import { call, takeLatest, all, put, select } from 'redux-saga/effects';
import api from 'services/api';
import { Types, Creators } from 'store/ducks/module/activity/delete';
import { Creators as ListCreators } from 'store/ducks/module/activity/byModule';
import Notifications from 'react-notification-system-redux';
import { callApi } from 'store/sagas/auth';

function* getActivityDelete({ payload }) {
  try {
    const { id } = payload;
    const request = call(api.delete, `/v1/admin/activities/${id}`);
    const response = yield call(callApi, request);

    if(response.status !== 200 && response.status !== 201) throw response;
    yield put(Creators.getActivityDeleteSuccess());
    const { activityList, activityListLoading } = yield select(
      state => state.module.activity.byModule,
    );
    yield put(
      ListCreators.getActivityListSuccess({
        data: activityList.filter(doc => doc.id !== id),
        total: activityListLoading - 1,
      }),
    );
    yield put(
      Notifications.success({ title: 'Atividade Deletada com sucesso' }),
    );
  } catch (err) {
    yield put(Creators.getActivityDeleteFailure('Erro ao buscar na API'));
  }
}

export default function* activityDeleteSaga() {
  yield all([takeLatest(Types.GET_DELETE_REQUEST, getActivityDelete)]);
}
